import React, {useRef} from "react";
import {Box} from "@mui/material";
import {PrimaryBigButton} from "../../components/buttons/mainButton";
import {useTranslation} from "react-i18next";
import {SideBarProperties} from "../sideBar/sideBarMenu";

interface PageFormProps {
  children: JSX.Element|JSX.Element[];
  submit: () => void;
  loading: boolean;
  loadingText?: JSX.Element;
  right?: boolean;
}

export default function PageForm(props: PageFormProps): JSX.Element {
  const {children, submit, loading, loadingText, right = false} = props;
  const {t} = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);

  const validate = (e: any): void => {
    e.preventDefault();
    submit();
  }

  return (
    <form onSubmit={validate}>
      <Box ref={contentRef} sx={{display: "flex", flexDirection: "column", alignItems: "center", mb: "88px"}}>
        {children}
      </Box>
      <Box sx={{display: "flex", justifyContent: !right ? "start" : "end", width: "100vw", height: "88px", pl: SideBarProperties[0].width, boxSizing: "border-box", position: "fixed", bottom: 0, left: 0, backgroundColor: "ornament.light", alignItems: "center", boxShadow: "inset 0px 1px 0px #CDCEDE"}}>
        <PrimaryBigButton sx={{ml : !right ? 3 : "0px", mr: !right ? "0px" : 3}} label={!(loading && loadingText) ? t("form.validate") : loadingText} action={validate} loading={!loadingText && loading} submit={true}/>
      </Box>
    </form>
  )
}
